import { searchAlgoliaConfig } from 'modules/search/algolia/searchAlgoliaConfig';
import { searchAlgoliaIndex } from 'modules/search/algolia/searchAlgoliaIndex';
import { algoliaGetObjects } from 'utils/algolia/algoliaGetObjects';

type Args = {
  listingIds: string[];
  attributes: string[];
};

export function searchAlgoliaFetchListingsById<T>({
  listingIds,
  attributes,
}: Args) {
  return algoliaGetObjects<T>({
    config: searchAlgoliaConfig(),
    index: searchAlgoliaIndex('newest'),
    ids: listingIds,
    attributes,
  });
}
